<template>
	<div class="bg-(--primary-beige) text-(--primary-brown) relative scrollbar-none scrollbar-thumb-transparent">
		<NavbarMobile
			v-if="activeRoute !== '/password'"
			class="lg:hidden"
		/>
		<div class="flex w-dvw h-15 items-center bg-(--secondary-brown) text-(--primary-beige) lg:hidden text-4xl font-serif! pl-3.75 transition duration-(--default-transition-duration) hover:scale-110">
			B & G
		</div>
		<Navbar
			v-if="activeRoute !== '/password'"
			class="hidden lg:flex"
		/>
		<slot />
		<Footer />
		<button
			class="scroll-to-top-button flex opacity-0 fixed lg:-translate-x-1/2 -translate-y-1/2 bottom-4 lg:bottom-0 right-1 lg:right-0 rounded-full size-7 items-center justify-center border-2 z-999 transition-shadow duration-(--default-transition-duration) hover:shadow-xl hover:cursor-pointer group "
			aria-label="Scroll to top"
			@click="scrollToTop"
			@mouseenter="onHoverIn"
			@mouseleave="onHoverOut"
		>
			<svg
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				xmlns="http://www.w3.org/2000/svg"
				aria-hidden="true"
				class="size-5"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M4.5 18.75l7.5-7.5 7.5 7.5M4.5 12.75l7.5-7.5 7.5 7.5"
				/>
			</svg>
		</button>
	</div>
</template>

<script setup lang="ts">
	import {
		useWindowScroll,
		useWindowSize
	} from "@vueuse/core";
	import {
		gsap
	} from "gsap";

	const { activeRoute } = utilityStores();
	const { y: scrollY } = useWindowScroll();
	const { width: windowWidth } = useWindowSize();
	const isScrolled = computed( () => scrollY.value > ( isMobile.value ? 64 : 0 ) );
	const isMobile = computed( () => windowWidth.value > 1024 );
	const scrollToTop = () => {
		scrollTo( {
			top: 0,
			behavior: "smooth"
		} );
	};

	onMounted( () => {
		gsap.set( ".scroll-to-top-button", { y: 100 } );
	} );

	watch( isScrolled, ( scrolled ) => {
		gsap.to( ".scroll-to-top-button", {
			y: scrolled ? 0 : 100,
			duration: 0.2,
			ease: "power2.out",
			opacity: 100
		} );
	} );

	const onHoverIn = () => {
		gsap.to( ".scroll-to-top-button", { scale: 1.05, duration: 0.2 } );
	};
	const onHoverOut = () => {
		gsap.to( ".scroll-to-top-button", { scale: 1, duration: 0.2 } );
	};
</script>